import React from 'react';
import { fmtDate } from '../../lib/dates';

const BLOCKS = [['contradicciones', 'Contradicciones'], ['debilidades', 'Debilidades'], ['evidencia_desfavorable', 'Evidencia desfavorable'], ['falta_evidencia', 'Sin evidencia suficiente']];

export const AdversarialView = ({ a }) => (
  <div data-testid="matrix-adversarial-result" className="rounded-xl border border-rose-500/30 bg-rose-500/5 p-4">
    <p className="text-sm font-semibold text-rose-200">Revisión adversarial · {fmtDate(a.at, true)}</p>
    <p className="text-[11px] text-slate-400">{a.metodo}</p>
    <div className="mt-2 grid gap-3 md:grid-cols-2">
      {BLOCKS.map(([k, l]) => (
        <div key={k}><p className="text-xs font-semibold text-slate-300">{l}</p>{(a[k] || []).length ? a[k].map((x, i) => <p key={i} className="text-xs text-slate-300">• {x}</p>) : <p className="text-xs text-slate-500">Ninguna detectada</p>}</div>
      ))}
    </div>
    {!!a.correcciones?.length && <div className="mt-3"><p className="text-xs font-semibold text-slate-300">Correcciones lícitas propuestas</p>{a.correcciones.map((c, i) => <p key={i} className="text-xs text-slate-300">• <span className="text-rose-200">{c.problema}</span> → {c.correccion}</p>)}</div>}
  </div>
);
